import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background-50 text-center px-4 pt-20">
      <div className="relative">
        <h1 className="text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none leading-none">
          404
        </h1>
        <div className="relative z-10 -mt-12 md:-mt-16">
          <h2 className="text-xl md:text-2xl font-semibold text-foreground-950">
            Seite nicht gefunden
          </h2>
          <p className="mt-2 text-base text-foreground-500 font-mono">{location.pathname}</p>
          <p className="mt-4 text-lg text-foreground-600">
            Diese Seite existiert leider nicht oder wurde verschoben.
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 mt-6 px-6 py-3 text-sm font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-left-line text-xs"></i>
            </span>
            Zurück zur Startseite
          </Link>
        </div>
      </div>
    </div>
  );
}